<template>
    <main class="maluku-prerender" data-prerender-kind="public-page">
        <h1>{{ $t('maluku.seoHeading') }}</h1>
        <MalukuIntroduction />
    </main>
</template>

<script setup>
import { onMounted, onScopeDispose } from 'vue';
import { useI18n } from 'vue-i18n';
import { useMalukuSeo } from '@/composables/useMaluku';
import { head } from '@/plugins/head';
import MalukuIntroduction from '@/components/maluku/MalukuIntroduction.vue';

const { t } = useI18n();
useMalukuSeo(() => t('maluku.seoTitle'), () => t('maluku.seoDescription'));
let stopReadyHook;
onMounted(() => {
    // Head updates are deferred beyond Vue's nextTick. Capture the snapshot
    // only after the localized metadata has actually reached the DOM.
    stopReadyHook = head.hooks.hook('dom:rendered', () => {
        stopReadyHook();
        document.dispatchEvent(new Event('sejarah-prerender-ready'));
    });
});
onScopeDispose(() => stopReadyHook?.());
</script>

<style scoped>
.maluku-prerender { max-width: 760px; margin: 0 auto; padding: 64px 24px; font-family: var(--font-primary); line-height: 1.6; }
.maluku-prerender h1 { margin: 0 0 24px; font-size: 2.25rem; line-height: 1.25; }
</style>
